export const APP_STORAGE_PREFIX = "SpLE";
